export class ItemSearchParams {

  words: string
  start: number
  limit: number
  filters: { time: string }

  constructor() {
    this.words = null
    this.start = 0
    this.limit = 10
    this.filters = { time: null }
  }

  public isEqualTo(params: any): boolean {
    return this.words === params.words && this.start === params.start && this.limit === params.limit
      && params.filters && this.filters.time === params.filters.time
  }

  get chosenPage(): number {
    return Math.round(this.start / this.limit)
  }

}



// WEBPACK FOOTER //
// ./src/app/models/item/item-search-params.ts